import { Col, Row } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import * as BullCache from "../../util/BullCache";
import { isMobile } from '../../util/GeneralUtil';
import MobileTopBar from './MobileTopBar';
import { ownSubscribe } from '../../stomp/StompSocket';
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { LoginService } from '../../services/LoginService';
const apiUrl = process.env.REACT_APP_API_URL;

function MobileMenubar({ activeMenu }) {
    var user = BullCache.getFromCache("user");
    const navigate = useNavigate();
    const [instruction, setInstruction] = useState(user.instruction); 

  useEffect(() => {
     const timeout =  setTimeout(() => {
      ownSubscribe('/topic/message/update/'+user.adminId, function (msg) {
              var admin = BullCache.getFromCache("user");
              setInstruction(msg.body);
              admin.instruction = msg.body;
              BullCache.saveToCache("user", admin);
            });
      }, 1500);

     return () => {
        clearTimeout(timeout);
      };

  }, []);

    useEffect(() => {
      const handleUnload = () => {
        const logoutData = JSON.stringify({ "loginId": user.adminId});
        navigator.sendBeacon(apiUrl + '/admin/logout2', logoutData); 
      };
  
      window.addEventListener('unload', handleUnload);
      return () => window.removeEventListener('unload', handleUnload);
    }, []);
  
    const handleLogout = () => {
        var request = {
              loginId: user.adminId
          }
       LoginService.doLogout(request).then(res => {
                navigate('/login');
            }).catch((error) => {
               navigate('/login');
        });
        
    };

  return (
    <>
    <Navbar expand="lg" className="bg-body-tertiary p-0">

      <Container className='pe-0'>
        <Row >
          <Col xs={2} xl={2} className='pt-1'>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />  
        <Navbar.Collapse id="basic-navbar-nav " className='fw-bold'>
          <Nav className="me-auto">
            {user.adminType == 'SUPER_ADMIN' ?
              <>
                <Nav.Link href="/admindashboard" className='mt-2'>Admin Dashboard</Nav.Link>
                 <Nav.Link href="/dashboard" >Dashboard</Nav.Link>
              </>
              : <Nav.Link href="/dashboard" className='mt-2'>Dashboard</Nav.Link>
            } 
           

            {isMobile ? (
              <Nav.Link href="/mobilewatch">Market Watch</Nav.Link>
            ) : <Nav.Link href="/marketwatch">Market Watch</Nav.Link>
            }

            <Nav.Link href="/summaryreport">Summary Report</Nav.Link>
            <NavDropdown title="Trading" id="basic-nav-dropdown">
              {!isMobile ? (
                <NavDropdown.Item href="/trade">Trade</NavDropdown.Item>
              ) : (
                <NavDropdown.Item href="/trademobile">Trade</NavDropdown.Item>
              )}
              {isMobile ? (
                <NavDropdown.Item href="/positionreport">Position</NavDropdown.Item>
              ) : <NavDropdown.Item href="/position">Position</NavDropdown.Item>
              }
                {user.adminType !== 'SUBBROKER' ?
              <NavDropdown.Item href="/marginmanagement">Margin Management </NavDropdown.Item> : ""}
              <NavDropdown.Divider />
              <NavDropdown.Item href="/blockedscript">
                Blocked Scripts
              </NavDropdown.Item>


            </NavDropdown>


            <NavDropdown title="Users" >
              {user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
                <>
                  <NavDropdown.Item href="/adminlist">Admin</NavDropdown.Item>
                </> : ""
              }
              {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'SUPER_MASTER' ?
                <>
                  <NavDropdown.Item href="/masterlist">Master</NavDropdown.Item>
                </> : ""}
              
              {user.adminType != 'SUBBROKER' ?
                <>
                  <NavDropdown.Item href="/subbroker">Broker</NavDropdown.Item>
                </> : ""}
              <NavDropdown.Item href="/customer">Customer</NavDropdown.Item>
              {user.adminType != 'SUBBROKER' ? <>
              <NavDropdown.Item href="/newaccount">New Account</NavDropdown.Item>
              </> : ""}
              {user.adminType == 'SUPER_ADMIN' ?
                 <>
                     <NavDropdown.Item href="/liveusers">Live Users</NavDropdown.Item>
                    <NavDropdown.Item href="/adminloginhistory">Admin Login History</NavDropdown.Item>
                 </> : ""
              }
            </NavDropdown>

          
            {user.adminType !== 'SUBBROKER' ?
            <NavDropdown title="Utilities" >
              <NavDropdown.Item href="/tradelog">Trade Log</NavDropdown.Item>
              <NavDropdown.Item href="/usereditlog">User Edit Log</NavDropdown.Item>
              {isMobile ? (
                <NavDropdown.Item href="/mobilerejectionlog">Rejection Log</NavDropdown.Item>
              ) : <NavDropdown.Item href="/rejectionlog">Rejection Log</NavDropdown.Item>
              }
            </NavDropdown> : ""}

            <NavDropdown title="Accounts" >
              <NavDropdown.Item href="/ledger">Ledger</NavDropdown.Item>
              {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' || user.adminType == 'SUPER_MASTER' ?
              <>
              <NavDropdown.Item href="/cashentry">Payment Entry</NavDropdown.Item>
              <NavDropdown.Item href="/cashledger">Payment Ledger</NavDropdown.Item>
              <NavDropdown.Item href="/jv">JV</NavDropdown.Item>
              <NavDropdown.Item href="/jvledger">JV Ledger</NavDropdown.Item>
              <NavDropdown.Item href="/jvbroker">JV Broker</NavDropdown.Item>
              <NavDropdown.Item href="/jvbrokerlist">JV Broker List</NavDropdown.Item>
              <NavDropdown.Item href="/trialbalance">Trial Balance</NavDropdown.Item></>: ""}
            </NavDropdown>

            <NavDropdown title="Reports" >
              <NavDropdown.Item href="/brokeragereport">Brokerage Report</NavDropdown.Item>
              <NavDropdown.Item href="/profitlosspercentage">Profit Loss Percentage</NavDropdown.Item>
              <NavDropdown.Item href="/shorttradereport">Short Trade Report</NavDropdown.Item>
              <NavDropdown.Item href="/shorttradereportv2"> Short Trade Report v2</NavDropdown.Item>
              <NavDropdown.Item href="/tradereport">Trade Report</NavDropdown.Item>

            </NavDropdown>

            {user.adminType !== 'SUBBROKER' ?
            <NavDropdown title="Settings" >
              <NavDropdown.Item href="/quantitysettings">Quantity Settings</NavDropdown.Item>
              <NavDropdown.Item href="/scriptblockallow">Script Block Allow</NavDropdown.Item>
              {user.adminType == 'SUPER_ADMIN' ?
                <>
                  <NavDropdown.Item href="/appconfig">App Config</NavDropdown.Item>
                  <NavDropdown.Item href="/socketconfig">Socket Config</NavDropdown.Item>
                </>
                : ""
              }
              {user.adminType == 'SUPER_ADMIN' ?
                <>
                  <NavDropdown.Item href="/scriptmargin">Script Margin</NavDropdown.Item>
                  <NavDropdown.Item href="/scriptconfig">Script Config</NavDropdown.Item>
                  <NavDropdown.Item href="/rateofpoint">Rate Of Point</NavDropdown.Item>
                  <NavDropdown.Item href="/closingrate">Closing Rate</NavDropdown.Item>
                </>
                : ""
              }
              <NavDropdown.Item href="/defaultsetting">Default Setting</NavDropdown.Item>
              {user.adminType == 'SUPER_ADMIN' ?
              <NavDropdown.Item href="/job">Job</NavDropdown.Item>
              :""}
            </NavDropdown>
            :""}
            <Nav.Link as="span" onClick={handleLogout} style={{ cursor: 'pointer' }}>Logout</Nav.Link>
          </Nav>
        </Navbar.Collapse>
        </Col>
        <Col xl={10} xs={10}>
          <MobileTopBar activeMenu={activeMenu}></MobileTopBar>
        </Col>
        </Row>

        

     </Container>
    </Navbar>
       {isMobile ?
          <Row className="no-print">
            <Col sm={12} xs={12} md={12} lg={12}>
                <marquee><span className="text-danger fw-bold ">{instruction}</span></marquee>
              </Col>
          </Row>
          : ""} 
    </>
    );

}
export default MobileMenubar;